import { gotSameRecurrenceSettings } from '@/utils'
import { computeInitialRecurrenceSettings } from '../../../../../utils/computeRecurrenceSettingFromOrder'

export function computeRecurrenceSettings(
  extOrders: uui.domain.client.rm.ExtendedOrderStep[],
  recurrences: Record<string, uui.domain.client.rm.Recurrence>,
  today: Date,
): uui.domain.ui.forms.BulkRecurrenceSettings {
  if (extOrders.length === 0) {
    return {
      status: 'mixed',
    }
  }

  let exact = true
  const refRecurrenceId = extOrders[0].order.recurrenceId

  for (const extOrder of extOrders) {
    const recurrenceId = extOrder.order.recurrenceId
    // If recurrenceIds are the same we can skip
    if (recurrenceId === refRecurrenceId) continue

    // If the first order got no recurrence and the current one has, or vice versa
    // we have a mixed case
    if (!!refRecurrenceId !== !!recurrenceId) {
      exact = false
      break
    }

    // If both orders have recurrence, we need to compare them
    if (
      refRecurrenceId &&
      recurrenceId &&
      !gotSameRecurrenceSettings(recurrences[refRecurrenceId], recurrences[recurrenceId])
    ) {
      exact = false
      break
    }
  }

  if (exact) {
    return {
      status: 'exact',
      value: computeInitialRecurrenceSettings(extOrders[0], recurrences, today),
    }
  }

  return {
    status: 'mixed',
  }
}
